import { render, staticRenderFns } from "./CampaignEditorLoader.vue?vue&type=template&id=522e35cd&"
import script from "./CampaignEditorLoader.vue?vue&type=script&lang=js&"
export * from "./CampaignEditorLoader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports